import React, { useState, useEffect } from "react";

export default function ReactionTest() {
    const [phase, setPhase] = useState("waiting"); // waiting | ready | go | done
    const [message, setMessage] = useState("Clicca su Avvia per iniziare");
    const [time, setTime] = useState(0);
    const [start, setStart] = useState(0);

    const startTest = () => {
        setPhase("ready");
        setMessage("Aspetta il verde...");
        const delay = Math.random() * 2000 + 1000;
        setTimeout(() => {
            setPhase("go");
            setMessage("CLICCA ORA!");
            setStart(Date.now());
        }, delay);
    };

    const handleClick = () => {
        if (phase === "go") {
            const diff = Date.now() - start;
            setTime(diff);
            setMessage(`Tempo di reazione: ${diff} ms`);
            setPhase("done");
        } else if (phase === "ready") {
            setMessage("Troppo presto! Riprova.");
            setPhase("done");
        }
    };

    return (
        <div
            onClick={handleClick}
            style={{
                textAlign: "center",
                padding: "2rem",
                background:
                    phase === "go"
                        ? "rgba(34,197,94,0.3)"
                        : phase === "ready"
                            ? "rgba(250,204,21,0.15)"
                            : "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                cursor: "pointer",
                userSelect: "none",
            }}
        >
            <h4 style={{ color: "#facc15" }}>
                <i className="fas fa-bolt" style={{ marginRight: "6px" }}></i> Reaction Test
            </h4>
            <p>{message}</p>
            {phase === "waiting" || phase === "done" ? (
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        startTest();
                    }}
                    style={{
                        background: "linear-gradient(135deg,#facc15,#ca8a04)",
                        border: "none",
                        color: "#000",
                        fontWeight: "700",
                        padding: "0.6rem 1.2rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                    }}
                >
                    <i className="fas fa-play" style={{ marginRight: "6px" }}></i> Avvia
                </button>
            ) : null}
            {time > 0 && (
                <p style={{ marginTop: "1rem", color: "#22c55e" }}>
                    <i className="fas fa-stopwatch" style={{ marginRight: "6px" }}></i> {time} ms
                </p>
            )}
        </div>
    );
}
